import Badge from './Badge';

export default Badge;  


// WEBPACK FOOTER //
// ./src/components/Badge/index.js